import React, { useMemo } from 'react';
import { DateUtils } from '@vectord/utils';

import { findLessonByLessonType, LESSON_TYPES } from 'features/classCreation';
import Field from 'components/Field';
import Input from 'components/Input';
import styles from './DiscussionDateAndTime.module.scss';
import toDDMMMYYYYHHMM from 'utils/toDDMMMYYYYHHMM';

function DiscussionDateAndTime({ sbatGroup }) {
  const { academy_topic: academyTopic } = sbatGroup || {};
  const { lessons } = academyTopic || {};
  const contest = findLessonByLessonType({
    lessons,
    lessonType: LESSON_TYPES.contest,
  });

  const discussionDateOfTopic = useMemo(() => {
    // Discussion's dateOfTopic is contest's dateOfTopic + duration of contest.
    // Discussion is supposed to be unlocked as soon as the contest ends.
    const dateOfTopic =
      new Date(sbatGroup.date_of_topic).getTime() +
      DateUtils.ONE_MINUTE * contest.duration;

    return toDDMMMYYYYHHMM(dateOfTopic);
  }, [contest, sbatGroup.date_of_topic]);

  return (
    <Field label="Discussion Date & Time">
      <Input
        value={discussionDateOfTopic}
        disabled
        className={styles.input}
      />
    </Field>
  );
}

export default DiscussionDateAndTime;
